import ManagePowerUsers from './ManagePowerUsers';
import { connect } from 'react-redux';
import {
  dashboardViewActions,
  dashboardViewErrorSel,
  dashboardViewPowerUsersSel,
  dashboardViewHasSucceedSel,
  dashboardViewIsPendingSel
} from 'src/store/modules/dashboardview';

const mapStateToProps = (state: any) => {
  return {
    isPending: dashboardViewIsPendingSel(state),
    hasError: dashboardViewErrorSel(state).hasFailed,
    errorMessage: dashboardViewErrorSel(state).message,
    powerUsers: dashboardViewPowerUsersSel(state),
    hasSucceed: dashboardViewHasSucceedSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onClearAlert: () => {
    dispatch(dashboardViewActions.setError());
    dispatch(dashboardViewActions.setHasSucceed(false));
  },
  searchPowerUsers: (searchText: string) =>
    dispatch(dashboardViewActions.searchPowerUsers(searchText)),
  addPowerUser: (
    email: string,
    fullName: string,
    handlerId: number,
    mobileNumber: string,
    password: string,
    username: string
  ) =>
    dispatch(
      dashboardViewActions.addPowerUser(
        email,
        fullName,
        handlerId,
        mobileNumber,
        password,
        username
      )
    ),
  deleteUser: (id: number) => dispatch(dashboardViewActions.deletePowerUser(id))
});

export const pureComponent = ManagePowerUsers;
export default connect(mapStateToProps, mapDispatchToProps)(ManagePowerUsers);

interface IDispatchFromProps {
  onClearAlert(): void;
  searchPowerUsers(searchText: string): void;
  addPowerUser(
    email: string,
    fullName: string,
    handlerId: number,
    mobileNumber: string,
    password: string,
    username: string
  ): void;
  deleteUser(id: number): void;
}
